module.exports = __webpack_public_path__ + "static/media/mantap-logo.a5de2b79.png";